module.exports = __webpack_public_path__ + "static/media/bdulogo.51f2e2b4.png";